const env = import.meta.env;

export const amplifyConfigData = {
  Auth: {
    mandatorySignIn: true,
    region: env.VITE_AWS_REGION,
    userPoolId: env.VITE_COGNITO_USER_POOL_ID,
    identityPoolId: env.VITE_COGNITO_IDENTITY_POOL_ID,
    userPoolWebClientId: env.VITE_COGNITO_APP_CLIENT_ID,
    authenticationFlowType: "CUSTOM_AUTH",
  },
  Storage: {
    AWSS3: {
      bucket: env.VITE_S3_BUCKET,
      region: env.VITE_AWS_REGION,
    },
  },
  API: {
    endpoints: [
      {
        name: env.VITE_API_NAME,
        endpoint: env.VITE_API_GATEWAY_URL,
        region: env.VITE_AWS_REGION,
      },
      {
        name: env.VITE_TRACKING_GATEWAY_SERVICE,
        endpoint: env.VITE_TRACKING_GATEWAY_URL,
        service: env.VITE_TRACKING_GATEWAY_SERVICE,
        region: env.VITE_AWS_REGION,
      },
      {
        name: env.VITE_API_NAME_CDL,
        endpoint: env.VITE_API_GATEWAY_URL_CDL,
        service: env.VITE_TRACKING_GATEWAY_SERVICE,
        region: env.VITE_AWS_REGION,
      },
      {
        name: env.VITE_API_NAME_CDL_DEV,
        endpoint: env.VITE_API_GATEWAY_URL_CDL_DEV,
        service: env.VITE_TRACKING_GATEWAY_SERVICE,
        region: env.VITE_AWS_REGION,
      },
    ],
  },
  Analytics: {
    disabled: true,
  },
};

export const amplifyConfigDataNewSetUp = {
  Auth: {
    mandatorySignIn: true,
    region: env.VITE_AWS_REGION,
    userPoolId: env.VITE_COGNITO_USER_POOL_ID,
    identityPoolId: env.VITE_COGNITO_IDENTITY_POOL_ID,
    userPoolWebClientId: env.VITE_COGNITO_APP_CLIENT_ID,
  },
  Storage: {
    AWSS3: {
      bucket: env.VITE_S3_BUCKET,
      region: env.VITE_AWS_REGION,
    },
  },
  API: {
    endpoints: [
      {
        name: env.VITE_API_NAME,
        endpoint: env.VITE_API_GATEWAY_URL_V2,
        region: env.VITE_AWS_REGION,
      },
      {
        name: env.VITE_TRACKING_GATEWAY_SERVICE,
        endpoint: env.VITE_TRACKING_GATEWAY_URL,
        service: env.VITE_TRACKING_GATEWAY_SERVICE,
        region: env.VITE_AWS_REGION,
      },
      {
        name: env.VITE_API_NAME_CDL,
        endpoint: env.VITE_API_GATEWAY_URL_CDL,
        service: env.VITE_TRACKING_GATEWAY_SERVICE,
        region: env.VITE_AWS_REGION,
      },
      {
        name: env.VITE_API_NAME_CDL_DEV,
        endpoint: env.VITE_API_GATEWAY_URL_CDL_DEV,
        service: env.VITE_TRACKING_GATEWAY_SERVICE,
        region: env.VITE_AWS_REGION,
      },
    ],
  },
  Analytics: {
    disabled: true,
  },
};

export const amplifyGoConfigData = {
  Auth: {
    mandatorySignIn: true,
    region: env.VITE_AWS_REGION,
    userPoolId: env.VITE_COGNITO_USER_POOL_ID,
    identityPoolId: env.VITE_COGNITO_IDENTITY_POOL_ID,
    userPoolWebClientId: env.VITE_COGNITO_APP_CLIENT_ID,
  },
  Storage: {
    AWSS3: {
      bucket: env.VITE_S3_BUCKET,
      region: env.VITE_AWS_REGION,
    },
  },
  API: {
    endpoints: [
      {
        name: env.VITE_API_NAME,
        endpoint: env.VITE_API_GATEWAY_URL_G0,
        region: env.VITE_AWS_REGION,
      },
      {
        name: env.VITE_TRACKING_GATEWAY_SERVICE,
        endpoint: env.VITE_TRACKING_GATEWAY_URL,
        service: env.VITE_TRACKING_GATEWAY_SERVICE,
        region: env.VITE_AWS_REGION,
      },
      {
        name: env.VITE_API_NAME_CDL,
        endpoint: env.VITE_API_GATEWAY_URL_CDL,
        service: env.VITE_TRACKING_GATEWAY_SERVICE,
        region: env.VITE_AWS_REGION,
      },
      {
        name: env.VITE_API_NAME_CDL_DEV,
        endpoint: env.VITE_API_GATEWAY_URL_CDL_DEV,
        service: env.VITE_TRACKING_GATEWAY_SERVICE,
        region: env.VITE_AWS_REGION,
      },
    ],
  },
  Analytics: {
    disabled: true,
  },
};

export const apiName = env.VITE_API_NAME;
export const apiNameCDL = env.VITE_API_NAME_CDL;
export const apiNameCDLDev = env.VITE_API_NAME_CDL_DEV;

export const amchartLicenseKey = env.VITE_AMCHART_LICENSE_KEY;

export type IAmplifyConfigData = typeof amplifyConfigData;
export type IAmplifyConfigDataNewSetUp = typeof amplifyConfigDataNewSetUp;
export type IAmplifyGoConfigData = typeof amplifyGoConfigData;
export const APIRoutes = {
  // mix panel error store
  apiMixPanelErrorStore: `/patient-centric-app-v2/mixpanel/log-error`,

  // User Signup:
  apiSignup: `/patient-centric-app-v2/admin/v3/users/complete-signup`,
  /** Admin: pending sign-ups (Bearer JWT; roles per API). Query: email and/or phone (partial match), limit, offset. */
  apiAdminPendingUsers: `/patient-centric-app-v2/admin/v3/users/pending`,
  /** Admin: activate pending user → clinic patient. Path: Cognito sub. */
  apiAdminActivateUser: `/patient-centric-app-v2/admin/v3/users/{cognito_user_id}/activate`,
  /**
   * Setup-mode "Reset password" → server-side this is a resend-invite.
   * Overwrites the member's Cognito password with the supplied temporary
   * value AND re-sends the Cognito invite (email + SMS) containing it.
   *
   * Path params: `clinic_id` (numeric) AND `cognito_user_id` (Cognito sub).
   * Body: `{ password: string }`.
   * Success: `{ message: string, invite_warnings: string[] }` — when
   * `invite_warnings` is non-empty the password WAS still reset but a
   * delivery channel failed (non-fatal; surface to the technician so they
   * can hand the password off in person).
   * Errors carry a `code` discriminator: `forbidden` / `clinic_mismatch` /
   * `user_not_found` / `user_not_in_clinic` / `cognito_error`.
   *
   * Caller authorization: must belong to the same clinic AND have a
   * clinic-user role or `setup_app_user` / `AccountManager` role.
   */
  apiResendInvite: `/patient-centric-app-v2/patient-app/clinic/{clinic_id}/users/{cognito_user_id}/resend-invite`,
  /**
   * Disconnect (unpair) a Circadia Device from the patient it's currently
   * assigned to. After success the device row's `patient_id` is null and
   * the device can be re-assigned to a different patient at next setup.
   *
   * Path params: `clinic_id` (numeric) AND `patient_id` (numeric — the
   * clinic-patient row id, same value surfaced as `user_id` on
   * `IClinicUser` and as `clinic_patient_id` from the activate endpoint)
   * AND `device_id` (string — the tracker MAC / serial).
   * No request body.
   * Success: `{ message: string, device: { id, device_id, clinic_id, patient_id, status } }`.
   *   `device.patient_id` is `null` after disconnect.
   * Errors carry a `code` discriminator: `forbidden` / `clinic_mismatch` /
   * `device_not_found` / `device_patient_mismatch`.
   *
   * Caller authorization: must belong to the same clinic AND have a
   * clinic-user role or `setup_app_user` role.
   */
  apiDisconnectDevice: `/patient-centric-app-v2/patient-app/clinic/{clinic_id}/patient/{patient_id}/device/{device_id}/disconnect`,

  // User Agreement
  userAgreement: `/user-agreement/userAgreement`,
  getPatientsList: `/patient-centric-app-v2/clinic/patient_list`,

  // Clinics
  apiMyClinic: `/patient-centric-app-v2/clinic/my-clinic-slim`,
  apiGetClinicFloor: `/patient-centric-app-v2/clinic/{clinic_id}/user-pref/floors`,
  apiSetClinicFloor: `/patient-centric-app-v2/clinic/{clinic_id}/user-pref/floors`,
  apiResidentList: `/patient-centric-app-v2/clinic/patient_list`,
  apiClinicDailyReportClinic: `/patient-centric-app-v2/v2/clinic_report`,

  // Alert
  apiGetAlertListNew: `/patient-centric-app-v2/clinic/{clinic_id}/v2/clinical-alerts`,
  apiGetAlertDetail: `/patient-centric-app-v2/clinic/{clinic_id}/patient/{resident_id}/v3/clinical-alerts/{alert_id}`,
  apiAddAlertComment: `/patient-centric-app-v2/clinic/{clinic_id}/acknowledge/alert/{alert_id}`,
  apiGetPSNAck: `/patient-centric-app-v2/clinic/{clinic_id}/PSN/alert/{alert_id}`,
  apiAddPSNAck: `/patient-centric-app-v2/clinic/{clinic_id}/psn_v2/alert/{alert_id}/ack`,
  apiGetCombinedAlertList: `/patient-centric-app-v2/clinic/{clinic_id}/patients/escalated-flagged/v2`,
  apiGetFlagList: `/patient-centric-app-v2/clinic/{clinic_id}/v2/patients/flagged`,
  apiAddAlertAck: `/patient-centric-app-v2/clinic/{clinic_id}/ack/alerts/v2`,
  apiPatientAlert: `/patient-centric-app-v2/clinic/{clinic_id}/patient/{patient_id}/escalated-flagged/v2`,
  apiGetFlagAlertClinical: `/patient-centric-app-v2/clinic/{clinic_id}/clinical-listing`,
  apiHideFlag: `/patient-centric-app-v2/clinic/{clinic_id}/psn_v2/alert/{flagged_id}/hide`,

  //Dashboard
  apiGetDashboardList: `/patient-centric-app-v2/clinic/{clinic_id}/cip/v2/psn-alerts`,
  apiGetPsnAlertGraphDataList: `/patient-centric-app-v2/clinic/{clinic_id}/patients/daily_rr_graph`,
  apiGetPatientListDashboard: `/patient-centric-app-v2/clinic/{clinic_id}/v2/recent/admissions`,
  apiGetReAdmitRadatMostCritical: `/patient-centric-app-v2/idt_reports/clinic/{clinic_id}/v2/readmit_radar/most-critical`,

  //s3
  apiGetFileFromS3: "/patient-centric-app-v2/aws/document",

  //support
  apiReportAProblem: `/patient-centric-app-v2/clinic/{clinic_id}/report-problem/cip/customer-support`,
  apiSubmitFeedback: `/patient-centric-app-v2/feedback/cip`,
  apiSubmitRating: `/patient-centric-app-v2/delighted/rating`,

  //push Notifications
  apiStoreToken: `/patient-centric-app-v2/v2/token`,
  apiGetNotificationSettings: `/patient-centric-app-v2/user/v4`,
  apiPutNotificationSettings: `/patient-centric-app-v2/user/preference/notification/v3`,

  //SMS
  apiSendOTP: `/patient-centric-app-v2/twilio/send-otp`,
  apiVerifyOTP: `/patient-centric-app-v2/verify-otp`,
  apiSavePhoneNumber: `/patient-centric-app-v2/user_info/user_phone_number`,

  //report
  apiGetClinicalReport: `/patient-centric-app-v2/clinic/{clinic_id}/daily_reports`,
  apiGetDailyReport: `/patient-centric-app-v2/clinic/{clinic_id}/daily_reports/{daily_report_id}`,
  apiAddReadDailyReport: `/patient-centric-app-v2/clinic/{clinic_id}/daily_reports/{daily_report_id}/read`,
  // report - AI risk report
  apiGetRiskReport: `/patient-centric-app-v2/idt_reports/clinic/{clinic_id}/v4/gpt/{date}`,
  apiGetReadmitRadar: `/patient-centric-app-v2/idt_reports/clinic/{clinic_id}/readmit_radar/v4`,
  apiGetRiskReportClinicPreference: `/patient-centric-app-v2/idt_reports/clinic/{clinic_id}/gpt/clinic_preference`,
  apiGetRiskReportList: `/patient-centric-app-v2/idt_reports/clinic/{clinic_id}/list/v2`,
  apiAckRiskReport: `/patient-centric-app-v2/idt_reports/clinic/{clinic_id}/ack/idt_report/{idt_report_id}`,

  // report - AI risk report public routes
  apiGetRiskReportPublicRoute: `/patient-centric-app-v2/idt_reports/link/summaries`,
  apiGetReadmitRadarPublicRoute: `/patient-centric-app-v2/idt_reports/link/readmit_radar`,
  apiGetRiskReportClinicPreferencePublicRoute: `/patient-centric-app-v2/idt_reports/clinic/{clinic_id}/gpt/clinic_preference`,
  apiGetRiskReportListPublicRoute: `/patient-centric-app-v2/idt_reports/clinic/{clinic_id}/list-`,
  apiAckRiskReportPublicRoute: `/patient-centric-app-v2/idt_reports/clinic/{clinic_id}/ack/idt_report/{idt_report_id}-`,

  //patient
  apiGetPatientList: `/patient-centric-app-v2/clinic/{clinic_id}/v2/patients`,
  apiGetPatientEventList: `/patient-centric-app-v2/clinic/{clinic_id}/resident/{resident_id}/v4/events`,
  apiGetPatientSummary: `/patient-centric-app-v2/clinic/{clinic_id}/resident/{resident_id}/v4/patient-chart-summary`,
  apiGetPatientCircadiaVital: `/patient-centric-app-v2/clinic/{clinic_id}/resident/{resident_id}/last-circadia-vitals`,
  apiGetPatientPCCVital: `/patient-centric-app-v2/clinic/{clinic_id}/resident/{resident_id}/last-pcc-vitals`,
  apiGetPatientRespRate: `/patient-centric-app-v2/clinic/{clinic_id}/patients/rr-metrics-psn`,
  apiGetPatientVitalGraph: `/patient-centric-app-v2/clinic/{clinic_id}/resident/{resident_id}/pcc-vitals-history`,
  apiGetPatientRRGraph: `/patient-centric-app-v2/clinic/{clinic_id}/patient/{resident_id}/rr_graph`,
  apiGetPatientNotes: `/patient-centric-app-v2/clinic/{clinic_id}/patient/{resident_id}/cip/combined-circadia-notes`,
  apiGetPatientPCCNotes: `/patient-centric-app-v2/clinic/{clinic_id}/patient/{resident_id}/pcc-notes`,
  apiAddPatientNote: `/patient-centric-app-v2/clinic/{clinic_id}/patient/{resident_id}/v2/notes`,
  // search
  apiGetSearch: `/patient-centric-app-v2/clinic/{clinic_id}/v3/patients`,

  apiGetAllPatientList: `/patient-centric-app-v2/clinic/{clinic_id}/resident/listing`,

  // Get all patients list (room assigned and not assigned) - V2 API
  apiGetAllPatientListV2: `/patient-centric-app-v2/clinic/{clinic_id}/v2/resident/listing`,

  //insights
  apiGetTOCAllowedMonths:
    "/patient-centric-app-v2/clinic/{clinic_id}/TOC/allowed_months",
  apiGetTOPAllowedMonths:
    "/patient-centric-app-v2/clinic/{clinic_id}/TOP/allowed_months",
  apiGetDischargeAllowedMonths:
    "/patient-centric-app-v2/clinic/{clinic_id}/discharge_insights/allowed_months",
  apiGetTOC: "/patient-centric-app-v2/clinic/{clinic_id}/v2/TOC",
  apiGetTOP: "/patient-centric-app-v2/clinic/{clinic_id}/TOP",
  apiGetDischarge:
    "/patient-centric-app-v2/clinic/{clinic_id}/v2/discharge_insights",
  apiGetTOCRootCause:
    "/patient-centric-app-v2/clinic/{clinic_id}/transfer_out/{TO_EVENT_ID}/RCA",

  //CDL Endpoints
  apiPatientGraphData: `/circadia-vitals/patient_processed/{patient_id}/`,
  apiPatientGraphDataV2: `/v2/circadia-vitals/patient_processed/`,
  // Intercom
  apiGetUserHmac: "/patient-centric-app-v2/user/intercom/token",

  // Agora RTC token (backend must return { token: string }; use App Certificate in Agora Console)
  apiGetAgoraToken: "/patient-centric-app-v2/agora/token",

  // Device onboarding: assign device to current user (POST body: { deviceId: string } or { macAddress: string })
  apiAssignDevice: "/patient-centric-app-v2/patient-app/device/assign",

  // Circadia IQ
  apiGenerateCircadiaIQ:
    "/patient-centric-app-v2/circadia_iq/v4/{clinic_id}/patient/{patient_id}",
  apiGetCircadiaIQ:
    "/patient-centric-app-v2/circadia_iq/v4/{clinic_id}/patient/{patient_id}/db",

  // bed exits
  apiAddBedExits: `/patient-centric-app-v2/user/bed-exit/settings/v2`,
  apiUpdateBedExitsTime: `/patient-centric-app-v2/user/bed-exit/settings/time`,
  apiUpdateBedExits: `/patient-centric-app-v2/user/bed-exit/settings/toggle/v3`,
  apiGetBedExitSettingsByUserPref: `/patient-centric-app-v2/clinic/{clinic_id}/user/bed-exits`,
  apiGetPatientNotificationSettings: `/patient-centric-app-v2/clinic/{clinic_id}/resident/{resident_id}/bed-exits`,
  apiGetDiagnoses:
    "/patient-centric-app-v2/clinic/{clinic_id}/resident/{resident_id}/patient-diagnosis",
  apiUpdatePatientNotificationSettings: `/patient-centric-app-v2/user/bed-exit/settings/v2`,
  apiUpdateCombineBedExits: `/patient-centric-app-v2/user/bed-exit/settings/combine`,

  // Bed Exit Event List
  apiGetBedExitEventList:
    "/patient-centric-app-v2/clinic/{clinic_id}/v2/bed-exit-events",

  apiGetBedExitFacilityReport:
    "/patient-centric-app-v2/clinic/{clinic_id}/bed-exit-comparison",

  // Users
  apiUserBetaFeature: `/patient-centric-app-v2/user/beta-feature`,

  // Tracking
  apiTracking: `/`,

  // Summary
  apiGetSummary: `/patient-centric-app-v2/clinic/{clinic_id}/v4/alerts/summary`,

  // IPV
  apiGetIPVNotesList: `/patient-centric-app-v2/clinic/{clinic_id}/v2/ipv_notes?status={status}`,
  apiAddIPVNotesAck: `/patient-centric-app-v2/clinic/{clinic_id}/acknowledge/ipv_note/{note_id}`,

  // Device Issues
  apiPostDeviceIssue: `/patient-centric-app-v2/clinic/{clinic_id}/device-issues`,

  // Home Health apis
  apiGetSinglePatientInfo: "/home_health/patient/{patient_id}",
  apiGetPatientGraphData: "/home_health/patient/{patient_id}/readings",
  apiGetSelectedFacilityPatientList: "/home_health/facility/{clinic_id}/",
  // User Info
  apiUpdateUserInfo: `/patient-centric-app-v2/user/v2/name`,

  // Sales
  apiAddSalesAck: `/patient-centric-app-v2/clinic/{clinic_id}/demo-request`,

  // VitalSync
  apiExtractVitals: `/patient-centric-app-v2/extract-vitals`,
  apiSubmitVitalsToPCC: `/patient-centric-app-v2/pcc/submit`,

  // Enrolment
  apiGetEnrolledPatients: `/pcc_blogger/clinic/{clinic_id}/patients`,
  apiGetPreviouslyEnrolledPatients: `/rtx/patients/status_base_list/{clinic_id}`,
  apiPutEnrollPatient: `/pcc_blogger/enrolment/new/{admission_id}`,
  apiPutExtendEnrollPatient: `/pcc_blogger/enrolment/update/{rtx_enrolment_id}`,

  // PSN v2 Review
  apiPutPSNAcknowledge: `/patient-centric-app-v2/clinic/{clinic_id}/psn_v2/shift_report/{notification_uuid}/ack`,

  apiGetFacilities: "/patient-centric-app-v2/clinics",
  apiAssignFacility: "/patient-centric-app-v2/users/{userId}/clinics",

  // HealthScribe APIs
  healthScribeStartRecording: `/patient-centric-app-v2/healthscribe/recording/start`,
  healthScribeStopRecording: `/patient-centric-app-v2/healthscribe/recording/stop`,
  healthScribeTranscriptionSave: `/patient-centric-app-v2/healthscribe/transcription/save`,
  healthScribeTranscriptionBatchSave: `/patient-centric-app-v2/healthscribe/transcription/batch-save`,
  healthScribeTranscriptionList: `/patient-centric-app-v2/healthscribe/transcription/list`,
  healthScribeTranscriptionCompleteGenerateNarrative: `/patient-centric-app-v2/healthscribe/transcription/complete`,
  healthScribeGetSession: `/patient-centric-app-v2/healthscribe/recording/clinic/{clinic_id}/session/{session_id}`,
  healthScribeListSessions: `/patient-centric-app-v2/healthscribe/recording/clinic/{clinic_id}/sessions`,
  healthScribeS3UploadInit: `/patient-centric-app-v2/healthscribe/s3/upload/init`,
  healthScribeS3UploadPart: `/patient-centric-app-v2/healthscribe/s3/upload/part`,
  healthScribeS3UploadComplete: `/patient-centric-app-v2/healthscribe/s3/upload/complete`,
  healthScribeS3UploadCompleteAudio: `/patient-centric-app-v2/healthscribe/s3/upload/audio`,
  healthScribeS3UploadAbort: `/patient-centric-app-v2/healthscribe/s3/clinic/{clinic_id}/upload/{session_id}/{upload_id}`,
  healthScribeS3UploadStatus: `/patient-centric-app-v2/healthscribe/s3/clinic/{clinic_id}/upload/status/{session_id}/{upload_id}`,

  // Initial Patient Visit (IPV) - Routes needed for getAllPatientsForIPV functionality
  apiGetIPVNotesByClinicID: `/patient-centric-app-v2/clinic/{clinic_id}/ipv_notes?status={status}`,
  apiGetAllIPVNotes: `/patient-centric-app-v2/clinic/{clinic_id}/patients/ipv_notes`,
  apiPostIPVNote: `/patient-centric-app-v2/clinic/{clinic_id}/patient/{patient_id}/ipv_notes`,
  apiGetIPVNotesByPatientID: `/patient-centric-app-v2/clinic/{clinic_id}/patient/{patient_id}/ipv_notes`,

  apiPutIPVNote: `/patient-centric-app-v2/clinic/{clinic_id}/patient/{patient_id}/ipv_notes/{ipv_note_id}`,

  apiFetchAssignedDeviceORAssingDeviceToAPatient:
    "/patient-centric-app-v2/patient-app/clinic/{clinic_id}/patient/{patient_id}/device", // GET or POST

  /** List all app users registered under a clinic. Path: clinic_id. Query: limit, offset. */
  apiGetClinicUsers: `/patient-centric-app-v2/patient-app/clinic/{clinic_id}/users`,

  // Prescriptions
  apiGetPrescriptions:
    "/patient-centric-app-v2/patient-app/clinic/{clinic_id}/patient/{patient_id}/prescriptions",
  apiUploadPrescription:
    "/patient-centric-app-v2/patient-app/clinic/{clinic_id}/patient/{patient_id}/prescriptions",
  apiGetPrescriptionById:
    "/patient-centric-app-v2/patient-app/clinic/{clinic_id}/patient/{patient_id}/prescriptions/{prescription_id}",
  apiDeletePrescription:
    "/patient-centric-app-v2/patient-app/clinic/{clinic_id}/patient/{patient_id}/prescriptions/{prescription_id}",

  // Reminders
  apiGetReminders:
    "/patient-centric-app-v2/patient-app/clinic/{clinic_id}/patient/{patient_id}/reminders",
  apiCreateReminder:
    "/patient-centric-app-v2/patient-app/clinic/{clinic_id}/patient/{patient_id}/reminders",
  apiGetReminderById:
    "/patient-centric-app-v2/patient-app/clinic/{clinic_id}/patient/{patient_id}/reminders/{reminder_id}",
  apiUpdateReminder:
    "/patient-centric-app-v2/patient-app/clinic/{clinic_id}/patient/{patient_id}/reminders/{reminder_id}",
  apiDeleteReminder:
    "/patient-centric-app-v2/patient-app/clinic/{clinic_id}/patient/{patient_id}/reminders/{reminder_id}",
} as const;

export type IAPIRoutes = typeof APIRoutes;
